export const RecycleRoutes = [
  {
    path: '/recycle',
    name: 'Recycle',
    component: () => import('@pages/recycle/index.vue'),
  },
]
